import { Customer, ICustomer } from '@precheckin/models/customer.model';
import { ETraineeType } from '@precheckin/models/enums/trainee-type.enum';
import { VisitStatus } from '@precheckin/models/enums/visit-status.enum';
import { EVisitorType } from '@precheckin/models/enums/visitor-type.enum';
import {
  ExportControl,
  IExportControl
} from '@precheckin/models/export-control/export-control.model';
import { cloneDeep } from 'lodash';

import { EVisitDocumentManagementStatus } from './visit-document-management-status.enum';
import { EVisitTsaStatus } from './visit-tsa-status.enum';

export interface IVisit {
  id: string;
  userId: string;
  startDate: string;
  endDate: string;
  trainingId: string;
  trainingCenterId: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  dateOfBirth: string;
  hotelName?: string;
  hotelPhone?: string;
  phone?: string;
  email?: string;
  emailConsentDate?: string;
  contactName?: string;
  identityPolicyConsentDate?: string;
  visitorType?: EVisitorType;
  traineeType?: ETraineeType;
  badgeNumber?: string;
  hostName?: string;
  visitReason?: string;
  drk?: string;
  lastStatusChange?: string;
  isBadgeActivated?: boolean;
  exportControl?: IExportControl;
  customer?: ICustomer;
  checkinStatus?: VisitStatus;
  tsaStatus?: EVisitTsaStatus;
  documentManagementStatus?: EVisitDocumentManagementStatus;

  checkPrecheckinSubmitted(): boolean;
}

export class Visit implements IVisit {
  id: string;
  userId: string;
  startDate: string;
  endDate: string;
  trainingId: string;
  trainingCenterId: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  dateOfBirth: string;
  hotelName?: string;
  hotelPhone?: string;
  phone?: string;
  email?: string;
  emailConsentDate?: string;
  contactName?: string;
  identityPolicyConsentDate?: string;
  visitorType?: EVisitorType;
  traineeType?: ETraineeType;
  badgeNumber?: string;
  visitReason?: string;
  hostName?: string;
  drk?: string;
  lastStatusChange?: string;
  isBadgeActivated?: boolean;
  exportControl?: ExportControl;
  customer?: Customer;
  tsaStatus?: EVisitTsaStatus;
  documentManagementStatus?: EVisitDocumentManagementStatus;
  checkinStatus?: VisitStatus;

  constructor(clone: Visit = null) {
    this.id = '';
    this.userId = '';
    this.startDate = '';
    this.endDate = '';
    this.trainingId = '';
    this.trainingCenterId = '';
    this.firstName = '';
    this.lastName = '';
    this.middleName = '';
    this.dateOfBirth = '';
    this.hotelName = '';
    this.hotelPhone = '';
    this.phone = '';
    this.email = '';
    this.emailConsentDate = '';
    this.contactName = '';
    this.identityPolicyConsentDate = '';
    this.visitorType = null;
    this.traineeType = null;
    this.badgeNumber = '';
    this.visitReason = '';
    this.hostName = '';
    this.drk = '';
    this.lastStatusChange = '';
    this.isBadgeActivated = false;
    this.exportControl = new ExportControl();
    this.customer = new Customer();
    this.tsaStatus = null;
    this.documentManagementStatus = null;
    this.checkinStatus = VisitStatus.CHECKIN_IN_PROGRESS;

    if (clone) {
      this.id = cloneDeep(clone.id);
      this.userId = cloneDeep(clone.userId);
      this.startDate = cloneDeep(clone.startDate);
      this.endDate = cloneDeep(clone.endDate);
      this.trainingId = cloneDeep(clone.trainingId);
      this.trainingCenterId = cloneDeep(clone.trainingCenterId);
      this.firstName = cloneDeep(clone.firstName);
      this.lastName = cloneDeep(clone.lastName);
      this.middleName = cloneDeep(clone.middleName);
      this.dateOfBirth = cloneDeep(clone.dateOfBirth);
      this.hotelName = cloneDeep(clone.hotelName);
      this.hotelPhone = cloneDeep(clone.hotelPhone);
      this.phone = cloneDeep(clone.phone);
      this.email = cloneDeep(clone.email);
      this.emailConsentDate = cloneDeep(clone.emailConsentDate);
      this.contactName = cloneDeep(clone.contactName);
      this.identityPolicyConsentDate = cloneDeep(clone.identityPolicyConsentDate);
      this.visitorType = cloneDeep(clone.visitorType);
      this.traineeType = cloneDeep(clone.traineeType);
      this.badgeNumber = cloneDeep(clone.badgeNumber);
      this.visitReason = cloneDeep(clone.visitReason);
      this.hostName = cloneDeep(clone.hostName);
      this.drk = cloneDeep(clone.drk);
      this.lastStatusChange = cloneDeep(clone.lastStatusChange);
      this.isBadgeActivated = cloneDeep(clone.isBadgeActivated);
      this.exportControl = cloneDeep(clone.exportControl);
      this.customer = cloneDeep(clone.customer);
      this.tsaStatus = cloneDeep(clone.tsaStatus);
      this.documentManagementStatus = cloneDeep(clone.documentManagementStatus);
      this.checkinStatus = cloneDeep(clone.checkinStatus);
    }
  }

  checkPrecheckinSubmitted(): boolean {
    return this.checkinStatus === VisitStatus.PRECHECKED_IN;
  }
}
